import { put, call, takeLatest } from "redux-saga/effects";
import { GAME_DASHBOARD_CARD_CREATE_REQUEST } from "../actionTypes/type";
import { actionSuccess, actionError } from "../actions/game_dashboard_card_create_action";
import { postApiCall } from "../../services/PostApiCall";
import { GAME_DASHBOARD_CARD_CREATE_URL } from "../../services/apiUrl";

export function* gameDashboardCardCreateSaga(action) {
  try {
    const response = yield call(postApiCall, action.params, GAME_DASHBOARD_CARD_CREATE_URL);
    yield put(actionSuccess(response.data.data));
    action.onSuccess();
  } catch (error) {
    yield put(actionError(error));
    action.onError(error);
  }
}

export function* watchGameDashboardCardCreateSaga() {
  yield takeLatest(GAME_DASHBOARD_CARD_CREATE_REQUEST, gameDashboardCardCreateSaga);
}
